 
export const No_transactions = ({
  message = "There are"
}) => (
  <div className="center items-back p-22 ">
    <div className="text-h1 bold blue fcap">{message}</div> 
    <div className="text-h3 text-off no-tx-text-loop ">
No data has been recorded for this. Please visit again.
    </div>
    {/* <img className="icon_photo center" src={emptyfile}></img>   */}
  </div>
);
